module.exports = __webpack_public_path__ + "img/logo.4b8a7317.svg";